import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import InvoiceFullDetails from '@accounting/components/pdf/invoice-layouts/invoice-full-details/invoice-full-details.vue';
import InvoiceSummary from '@accounting/components/pdf/invoice-layouts/invoice-summary/invoice-summary.vue';
import ModulesHelper from '@core/services/modules.helper';
import { InvoiceDetail } from '@accounting/interfaces/invoice';
@Component({
  name: 'bpc-invoice-details-presentational',
  components: {
    'bpc-invoice-full-details': InvoiceFullDetails,
    'bpc-invoice-summary': InvoiceSummary,
  },
})
export default class InvoiceDetailsPresentational extends Vue {
  @Prop(Boolean) readonly autoDownload: boolean;
  @Prop(String) readonly invoiceCode: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Object }) readonly invoice: InvoiceDetail;
  @Prop({ type: String, default: 'full_details' }) readonly invoiceLayout: string;

  numberOfOrdersLines: number = 0;
  hasSubvention: boolean = false;

  mounted() {
    this.getInvoiceInfo(this.invoice);
  }

  getInvoiceInfo(item: InvoiceDetail) {
    const orders = item?.orders || [];
    this.numberOfOrdersLines = orders.reduce((total, order) => {
      const orderLines = (order?.order_items || []).length + 1;
      total = total + orderLines;
      return total;
    }, 0);

    this.hasSubvention = this.invoiceHasSubvention(item);
  }

  get minLinesForFooter(): number {
    if (this.groupSubventionOnInvoices && this.hasSubvention) {
      return 10;
    }

    return 7;
  }

  get footerHeight(): number {
    if (this.groupSubventionOnInvoices && this.hasSubvention) {
      return 300;
    }

    return 200;
  }

  isTaxManagementModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.TAX_MANAGEMENT_MODULE_NAME);
  }

  get groupSubventionOnInvoices(): boolean {
    return !!this.$store.getters['centerSettings/groupSubventionOnInvoices'];
  }

  invoiceHasSubvention(invoice): boolean {
    return !!(invoice?.orders || []).find(item => item.type === 'subvention');
  }
}
